import React, { PropTypes } from 'react';
import { reduxForm } from 'redux-form';
import Input from '../form/Input';
import EditDialog from '../EditDialog';
import Manager, { MANAGER_ROLE_PRODUCT } from '../../api/manager';
import ClubSelector from '../Clubs/ClubSelector';
import validateTool from 'validate.js';
import RadioGroup from '../form/RadioGroup';
import managerCRUDActions from '../../actions/manager';

const validate = (data, props) => {
  let {first_name, last_name, email, password, role, club_id} = Manager.validateConstraints;

  password.presence = props.isNew;
  role.presence = {
    message: '^Please choose a role'
  };

  club_id.presence = data.role !== MANAGER_ROLE_PRODUCT
    ? {message: '^Please choose an account'}
    : false;

  return validateTool(data, {
      club_id,
      first_name,
      last_name,
      email,
      password,
      role
    }) || {};
};

class ManagerEditForm extends React.Component {
  static propTypes = {
    isNew: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    goIndex: PropTypes.func.isRequired,
    model: PropTypes.object.isRequired,
    save: PropTypes.func.isRequired,
    denyChangeClub: PropTypes.bool,
  };

  save(data) {
    let {model, save} = this.props;
    return save(model, data);
  }

  processSubmit() {
    return this.props.handleSubmit(data => this.save(data))(this.props.values);
  }

  render() {
    let {
          title,
          goIndex,
          isNew,
          fields: { first_name, last_name, email, club_id, password, role },
          submitting,
          denyChangeClub
        } = this.props;

    return (
      <form onSubmit={this.processSubmit.bind(this)}>
        <EditDialog
          title={title}
          disabledSave={submitting}
          onSubmit={() => this.processSubmit()}
          onDialogClosed={goIndex}
        >
          <RadioGroup label="Role" inline={true}
                      required={true}
                      options={Manager.roles}
            {...role}/>
          <Input label="First name" type="text" required {...first_name} />
          <Input label="Last name" type="text" required {...last_name} />
          <Input label="E-Mail" type="email" required {...email} />
          <Input label="Password" type="password" required={isNew} {...password} />
          {!denyChangeClub && <ClubSelector label="Account(s)" {...club_id} />}
        </EditDialog>
      </form>
    );
  }
}


export default reduxForm(
  {
    form: 'manager_edit',
    fields: ['first_name', 'last_name', 'email', 'club_id', 'password', 'role'],
    returnRejectedSubmitPromise: true,
    validate
  },
  undefined,
  (dispatch) => ({
    save: (item, data) => dispatch(managerCRUDActions.save(item, data))
  })
)(ManagerEditForm);





// WEBPACK FOOTER //
// ./src/components/Managers/ManagerEditForm.jsx